import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState , Fragment } from 'react'
import { Button, Alert, Card, CardBody, CardFooter, Col, DropdownItem, DropdownMenu, DropdownToggle, Media, Row, UncontrolledDropdown } from 'reactstrap';
import { findMyPaysAsProvider } from '../../helpers/api/finance';
import useSWRFetchPagination from '../../helpers/hooks/useSWRFetchPagination';
import FalconCardHeader from '../common/FalconCardHeader';
import Calendar from '../common/Calendar';
import PageHeader from '../common/PageHeader';
import { Link } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import FullPagination from '../common/pagination/FullPagination';
import { useSelector } from 'react-redux';
import withRedirect from '../../helpers/hoc/withRedirect';
import Filter from '../common/Filter';
import { Message, Or, PreloadState } from '../UI/preloading/PreloadState';
import { isIterableArray } from '../../helpers/utils';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import SupportLink from '../root/support/components/SupportLink';
import useModuleBase from "../../helpers/hooks/useModuleBase";
import VoidPaymentModal from "./VoidPaymentModal";

const Payments = () => {

    const moduleBase = useModuleBase();

    const { selectedCondominium } = useSelector(state => state.condominium);
    const { role } = useSelector(state => state.auth.user);
    const [voidTarget, setVoidTarget] = useState(null);
    const history = useHistory();

    const [params, setParams] = useState({ status: null, condominiumId: selectedCondominium, start_date: null, end_date: null })

    const filter_options = [
        { value: 0, displayName: 'Todos', disabled: false },
        { value: 'pending', displayName: 'Pendientes', disabled: false },
        { value: 'approved', displayName: 'Aprobados', disabled: false },
        { value: 'refused', displayName: 'Cancelados', disabled: false },
    ];

    const {
        data,
        error,
        isLoading,
        meta,
        mutate,
        handler:
        {
            goToPage,
            nextPage,
            perPage,
            previousPage
        },
    } = useSWRFetchPagination(findMyPaysAsProvider, params);

    const months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

    const renderItems = () => data.map((payment, i) => {
        const date = new Date(payment?.created_at);
        // eslint-disable-next-line react/jsx-key
        return (<Row className={payment?.voided_at ? 'alert-secondary border-top py-3' : 'alert-success border-top py-3'}>
            <Col>
                <Row>
                    <Col>
                        <Row>
                            <Col xs={9} className='d-flex align-items-center'>
                                <Media>
                                    <Calendar month={months[date.getMonth()]} day={date.getDate()} />
                                    <Media body className="position-relative pl-3 align-self-center">
                                        <p className='mb-0'>Pago al proveedor {payment?.debts_to_pay_id?.finance?.provider?.name} </p>
                                        <p className='fs--1 mb-0 font-weight-bolder'>{payment?.voided_at ? 'Anulado' : 'Pago realizado'}</p>
                                        {payment?.voided_at && payment?.void_reason && <p className='fs--2 mb-0 text-600'>Motivo: {payment.void_reason}</p>}
                                    </Media>
                                </Media>
                            </Col>
                            <Col xs={3} className=' d-flex align-items-center justify-content-end'>
                                <Media>
                                    <Media body className="border-left position-relative pl-3">
                                        <p className='mb-0 font-weight-bolder'>Monto</p>
                                        <p className="fs--1 mb-0 text-600"><NumberFormat displayType='text' value={payment?.amount} thousandSeparator decimalScale={2} fixedDecimalScale prefix='$ ' /></p>
                                    </Media>
                                </Media>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs='auto' className="d-sm-flex align-items-center justify-content-end">
                        <UncontrolledDropdown direction="left" className="d-inline-block ml-2">
                            <DropdownToggle color="falcon-default" size="sm">
                                <FontAwesomeIcon icon="ellipsis-h" />
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem
                               
                           /*     onClick={() => handleEdit(cost.id)} */
                                   onClick={() =>
                                    history.push({
                                      pathname: `/dashboard/${moduleBase}/${selectedCondominium}/topay-provider/edit/${payment.debts_to_pay_id.id}`,
                                    })
                                  }
                                >
                                  Ver detalles
                                </DropdownItem>
                                {role === 'manager' && !payment?.voided_at && (
                                  <DropdownItem className='text-danger' onClick={() => setVoidTarget(payment.id)}>
                                    Anular pago
                                  </DropdownItem>
                                )}
                              </DropdownMenu>
                        </UncontrolledDropdown>
                    </Col>
                </Row>
            </Col>
        </Row>
        )
    });

    return (
        <Fragment>
            <VoidPaymentModal
                isOpen={voidTarget !== null}
                toggle={() => setVoidTarget(null)}
                kind='provider'
                paymentId={voidTarget}
                onVoided={() => mutate()}
            />
            <PageHeader
                title="Pagos a proveedores" titleTag="h2"
                description={'Visualiza los pagos de los propietarios del condominio.'}
                className="mb-3" col={{ lg: 9 }}
            >
                {role === 'manager' && <SupportLink />}
            </PageHeader>

            <Card>
                <FalconCardHeader title='Pagos realizados'>
                    <Row>
                        <Col xs={12}>
                            < Filter
                                keyField='status'
                                options={filter_options}
                                selectType={setParams}
                                dateFilter={true}
                            />
                        </Col>
                    </Row>
                </FalconCardHeader>
                <CardBody className='fs--1 pt-0'>
                    <PreloadState cond={isIterableArray(data)} loading={isLoading}>
                        <Or value={true}>
                            {renderItems()}
                        </Or>

                        <Or value={false} cond={!!error}>
                            <Message value={false} color={'info'} className='p-3' align='left' icon={faInfoCircle}>
                                <>
                                    Aún no hay pagos para mostrar
                                    {role === 'manager' &&
                                        <>
                                            , puedes crear uno ahora mismo pulsando el siguiente enlace
                                            <Button data-testid="Button" tag={Link} color="link" size="sm" className="ml-1 pl-0" to={`/dashboard/${moduleBase}/${selectedCondominium}/topay/create`}>
                                                Crear cuenta por pagar
                                            </Button>
                                        </>}
                                </>
                            </Message>
                            <Or value={true}>
                                <Alert color="danger" className="mb-0">
                                    Esta página no está disponible
                                    <Button data-testid="Button" color="link" size="sm" className="ml-1 pl-0" onClick={() => history.goBack()}>
                                        Volver
                                    </Button>
                                </Alert>
                            </Or>
                        </Or>
                    </PreloadState>
                </CardBody>
                <CardFooter>
                    {isIterableArray(data) &&
                        <FullPagination
                            nextPage={nextPage}
                            prevPage={previousPage}
                            goToPage={goToPage}
                            meta={meta}
                            className={'shadow-none'}
                            posText={"pagos"}
                            perPage={perPage} />
                    }
                </CardFooter>
            </Card>
        </Fragment>
    )
}

export default withRedirect(Payments);